import { type SharedDocument, DocumentType } from 'types/Document';
import { type PartnerPublishedContent } from 'types/Partner';

const compareContentsByPublicationStartDate = <
  T extends PartnerPublishedContent,
>(
  a: T,
  b: T,
) => {
  const aPublicationStartDate = a?.publicationStartDate || 0;
  const bPublicationStartDate = b?.publicationStartDate || 0;

  return aPublicationStartDate > bPublicationStartDate ? 1 : -1;
};

export const sortContentsByPublicationStartDate = <
  T extends PartnerPublishedContent,
>(
  contents: T[],
): T[] => contents.sort(compareContentsByPublicationStartDate);

type GetPartnerContentContentFromS3InputType = {
  contentId: string;
  s3URL: string | undefined;
  callback: (value: string | undefined) => void;
};

export const getPartnerContentFromS3 = ({
  contentId,
  s3URL,
  callback,
}: GetPartnerContentContentFromS3InputType): void => {
  if (s3URL) {
    fetch(s3URL)
      .then((response) => {
        response
          .text()
          .then((value) => callback(value))
          .catch((error) =>
            console.error(`Error getting text content ${contentId}`, error),
          );
      })
      .catch((error) =>
        console.error(`Error retrieving content ${contentId}`, error),
      );
  } else {
    callback(undefined);
  }
};

export const filterImageDocument = (
  documents: SharedDocument[],
): SharedDocument[] =>
  documents.filter(
    (document) => document.type === DocumentType.PICTURE,
  );